/* istanbul ignore file */
import { string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const PatchSnippetCourseDataParser = 
/* #__PURE__ */ parsers.object([
    ['key', codecString],
    ['value', codecString],
]);
export class PatchSnippetCourseData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return PatchSnippetCourseDataParser.decode(input).map(res => new PatchSnippetCourseData(res));
    }
    static unsafeDecode(input) {
        return PatchSnippetCourseData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return PatchSnippetCourseDataParser.encode(data);
    }
    static schema() {
        return PatchSnippetCourseDataParser.schema();
    }
}
